export default {
    promotion: modules => {
        const mergeModules = [
            'md-header-pp-standard',
            'md-pp-banner-standard',
            'md-pp-video-standard',
            'md-pp-gallery-standard',
            'md-pp-detail-standard',
            'md-school-map-standard',
            'md-house-listing-pp',
            'md-form-column-agent'
        ];
        let matchModuleNum = 0;
        modules.forEach(item => {
            if (mergeModules.includes(item.componentName)) {
                matchModuleNum += 1;
            }
        });
        if (matchModuleNum >= mergeModules.length - 1) {
            return import(
                /* webpackChunkName: "merge-resource/promotion"*/ './promotion'
            );
        } else {
            return null;
        }
    }
};
